import React, { useEffect, useState } from 'react';

import { Props as ModalProps, Styles } from 'react-modal';

import LoadingContainer from 'components/LoadingContainer';
import Achievement from 'interfaces/Achievement';

import { Container, ImageContainer, Content, CloseButton } from './styles';

interface AchievementModalProps extends ModalProps {
  achievement: Achievement;
  imgUrl: string;
  handleCloseModal: () => void;
}

const customStyle: Styles = {
  content: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: '130px',
  },
};

const AchievementModal: React.FC<AchievementModalProps> = ({
  achievement,
  imgUrl,
  handleCloseModal,
  ...props
}) => {
  const [imgSrc, setImgSrc] = useState(imgUrl);
  const [imageLoading, setImageLoading] = useState(false);

  useEffect(() => {
    setImageLoading(true);

    const img = new Image();
    img.src = imgUrl;
    img.onload = () => {
      setImgSrc(imgUrl);
      setImageLoading(false);
    };
  }, [imgSrc, imgUrl]);

  return (
    <Container {...props} style={customStyle}>
      <ImageContainer>
        {imageLoading ? (
          <LoadingContainer style={{ height: '180px' }} />
        ) : (
          <img src={imgSrc} alt={achievement.id} />
        )}
      </ImageContainer>
      <Content>
        <h1>{achievement.name}</h1>
        <p>{achievement.description}</p>
        <p>
          <span>{achievement.points} pontos</span>
        </p>
        <CloseButton onClick={handleCloseModal}>Voltar</CloseButton>
      </Content>
    </Container>
  );
};

export default AchievementModal;
